export const routes = {
  root: "/",
  home: "home",
  viewDetails: "viewDetails",
  resourceManager: "resourceManager",
  userManagement: "userManagement",
  engagementManager: "engagementManager",
  powerBiDashboard: "powerBiDashboard",
};

export const buildDomainRoute = (domain, page) =>
  `/${domain}/${page}`;
